/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Commit_Message_LabelInputs */



/**
* | output |
* | --- |
* | "Commit Message" |
*
* @param {Team_Sync_Commit_Message_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_commit_message_label = /** @type {((inputs?: Team_Sync_Commit_Message_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Commit_Message_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Message de commit")
	if (locale === "de") return /** @type {LocalizedString} */ ("Commit-Nachricht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Messaggio di commit")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сообщение о подтверждении")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mensaje de confirmación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("提交信息")
	if (locale === "ja") return /** @type {LocalizedString} */ ("コミットメッセージ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिबद्धता संदेश")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mensagem de confirmação")
	return /** @type {LocalizedString} */ ("Commit Message")
});